const guidGenerator = () => {
  var S4 = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
};

const basicReducer = (state, action) => {
  if (action.type === "merge") {
    return {
      ...state,
      ...action.data,
    };
  }

  if (action.type === "update") {
    return {
      ...state,
      [action.key]: action.value,
    };
  }

  if (action.type === "remove") {
    let newState = { ...state };
    if (action.key in newState) delete newState[action.key];
    return newState;
  }

  if (action.type === "reset") {
    if (action.data) return action.data;
    return {};
  }

  return state;
};

export { guidGenerator, basicReducer };
